import { useMemo, useState } from 'react';

import { useCareStateDomain } from '@/entities/care-state-domain';

import { getActionReceipts, getOpenRequestsCount } from './selectors';
import type { UseRequestsCompletionPromptResult } from './types';

export function useRequestsCompletionPrompt(): UseRequestsCompletionPromptResult {
  const { careState, debug, status, patientUserId } = useCareStateDomain();

  const openCount = useMemo(() => getOpenRequestsCount(careState), [careState]);
  const actionReceipts = useMemo(() => getActionReceipts(careState), [careState]);
  const isSettled = status === 'ready' && debug.pendingUpdateCount === 0;
  const [trackedPatient, setTrackedPatient] = useState(patientUserId);
  const [hasSeenOpenRequests, setHasSeenOpenRequests] = useState(false);

  if (trackedPatient !== patientUserId) {
    setTrackedPatient(patientUserId);
    setHasSeenOpenRequests(false);
  }
  if (isSettled && openCount > 0 && !hasSeenOpenRequests) {
    setHasSeenOpenRequests(true);
  }

  const shouldShowPrompt = isSettled && hasSeenOpenRequests && openCount === 0;
  return { openCount, isSettled, patientUserId, shouldShowPrompt, actionReceipts };
}
